var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageCareHistoryLabWorks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.555 80.728v-35.88h63.469v60.907a61.004 61.004 0 1 0-91.645 12.068c.37-13.104 2.206-28.018 6.894-32.706.86-.86 11.174-3.435 21.282-4.389Z",
    fill: "#FDD59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.135 39.52s1.923-.587 2.446 1.973c.083.409 2.902.401 2.902.401l.626 2 4.553 3.292-2.81 4.686-2.902 3.178-5.486-1.877-.984-5.93 2.115-5.974-.46-1.75Z",
    fill: "#F26A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.486 42.86a1.138 1.138 0 0 1-.766 1.336l-4.33.883a1.014 1.014 0 0 1-1.119-.952 1.137 1.137 0 0 1 .766-1.337l4.331-.884a1.014 1.014 0 0 1 1.118.953Z",
    fill: "#FC8B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.385 41.29c.645.454 1.082.84.641.895l-4.768.613a1.21 1.21 0 0 1-1.138-.863c-.186-.53.018-1.005.459-1.058l3.666-.45a1.21 1.21 0 0 1 1.14.863Z",
    fill: "#FC8B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.278 40.606-2.784-.077a1.103 1.103 0 0 1-.997-.81c-.162-.484.028-.904.42-.94 0 0 1.339-.502 2.275.156.76.535 1.478 1.636 1.086 1.67ZM95.149 44.789c.07.53.951 2.319.513 2.398l-4.822-.636a.85.85 0 0 1-.918-.82.952.952 0 0 1 .665-1.103l3.818-1.05c.439-.08.674.678.744 1.21Z",
    fill: "#FC8B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.458 22.967c-1.858 9.887 3.504 10.008 3.504 10.008 2.633 26.57-22.729 4.462-22.964.307 5.302-.665 7.486-4.003 8.738-9.423-.634-3.993 10.722-.892 10.722-.892Z",
    fill: "#F26A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.743 61.312-8.09-16.843c-8.848-17.078-20.639-13.826-20.639-13.826l-.918 14.184-16-13.278s-11.958.112-18.933 18.037c-2.925 6.844 10.076 25.385 11.976 33.03-1.04 7.102 32.508 4.833 39.546-.483.513-3.727 1.238-11.251 2.061-18.684l.336.677 10.662-2.814Z",
    fill: "#FFAA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.802 51.184H33.867v6.936h12.935v-6.936Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.555 119.91V80.728c-10.108.954-20.422 3.529-21.282 4.389-4.688 4.688-6.524 19.602-6.894 32.706a61.088 61.088 0 0 0 56.119 13.509c-.46-3.379-.89-7.281-1.368-11.422H48.555Z",
    fill: "#FFAA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.554 44.847v35.88c7.333-.692 14.558-.531 17.986 1.755 5.062 8.78 7.073 24.298 8.59 37.427h24.028a61.313 61.313 0 0 0 12.866-14.155V44.847h-63.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.554 80.728v39.182H75.13c-1.516-13.129-3.527-28.648-8.589-37.428-3.428-2.286-10.653-2.446-17.986-1.754Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.005 52.1s6.77-2.639 9.867 7.413c1.113 3.611-2.172 24.531-2.172 24.531l16.7 16.949a10.782 10.782 0 0 1 1.76.006l3.76.87 7.017 1.886 2.101-.809s.616 2.35-2.452 3.348c-.49.158-2.38.122-2.38.122l3.85 5.603c.24.539-.102 1.274-.765 1.643-.577.32-1.209.257-1.517-.124a1.567 1.567 0 0 1-.974 1.534 1.34 1.34 0 0 1-1.46-.097c.157.589-.31 1.333-1.076 1.696-.8.375-1.62.195-1.833-.402l-.117-.334a1.468 1.468 0 0 1-.792.891 1.131 1.131 0 0 1-1.212-.071v.001l-4.297-2.441-2.526-3.579-1.224-2.127c-2.764-1.937-21.188-15.044-23.645-22.237-2.05-6.008 3.387-34.272 3.387-34.272Z",
    fill: "#FC8B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.262 68.916 11.64 66.879l3.17-15.975 19.17.6-7.718 17.412Z",
    fill: "#FFAA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.47 18.534c-.592.418-2.167-.36-2.804-.017-.676.364-.45 1.862-1.122 2.116-.733.28-2.306-.717-3.066-.563-.86.173-1.02 1.507-1.846 1.5-.975-.006-2.357-1.387-3.291-1.707-1.094-.377-2.27.042-3.202-.803-.938-.855-.887-2.35-1.4-3.538-.439-1.02-1.89-2.32-1.998-3.495-.09-1.003 1.195-1.457 1.394-2.45.174-.885-.743-2.58-.325-3.436.386-.787 2.008-.556 2.592-1.225.545-.634.151-2.32.895-2.843.747-.524 2.456.235 3.27-.09.862-.347 1.011-1.825 1.95-1.97 1.02-.155 2.612 1.063 3.603 1.127 1.114.07 1.917-.944 2.97-.62 1.233.385 2.27 1.974 3.255 2.61 1.148.742 2.765 1.065 3.449 2.096.68 1.026-.06 1.952.077 3.003.114.9 1.255 2.448 1.023 3.306-.195.725-1.666.537-2.062 1.248-.352.629.332 2.25-.147 2.826-.439.528-1.99-.039-2.546.464-.524.473-.077 2.045-.67 2.461Z",
    fill: "#FDBB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.648 19.069c-.607-3.012-1.725-7.764-.93-9.997.92-2.599 3.524-3.342 5.798-3.801 2.276-.459 4.964-.781 6.823 1.256 1.596 1.751 2.18 6.002 2.598 9.046.535 3.884.86 6.435-1.927 10.212-.641.871-1.24 3.02-6.244.534-3.286-1.632-5.344-3.414-6.118-7.25Z",
    fill: "#FC8B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.848 17.77c-3.073-1.747-1.301 2.688-.443 3.762.316.397 1.186 1.124 1.778 1.115l-1.335-4.876Z",
    fill: "#FC8B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.65 17.81c-.63-.177 2.935 4.694-1.09 7.07-3.839-2.551-4.788-4.424-5.394-5.885-2.289-5.52.034-12.035.034-12.035s1.456-3.439 6.887-4.533c2.468-.5 7.53-.203 9.88 1.358 1.976 1.314 3.62 4.065 2.65 5.161-.653-.729-3.93-2.082-4.684-.948-6.816-1.136-2.954 7.43-8.283 9.812Z",
    fill: "#FDBB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.894 13.599c-.66-.418-2.59-.035-3.343.44-.271.169-.505.237-.45.536 1.474-.835 3.093-.443 3.77-.924l.023-.052ZM48.974 15.574s-.424-.7-.72-.709c-.577-.019-2.3.903-2.3.903l.56.978.189-.694s1.039-.846 1.454-.86c.3.058.58.189.817.382Z",
    fill: "#43200C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.37 16.132a.726.726 0 1 0 .518-.762.659.659 0 0 0-.519.762ZM51.141 12.939c.256-.687 1.368-1.197 2.137-1.17.276.009.474-.049.586.233-1.457.026-1.963 1.041-2.68.97l-.043-.033ZM51.633 14.793s-.05-.808.152-.965c.398-.305 2.074-.38 2.074-.38l.095 1.114-.48-.498s-1.157-.202-1.455-.004c-.228.15-.386.732-.386.732Z",
    fill: "#43200C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.002 14.244a.606.606 0 1 1-.746-.39.597.597 0 0 1 .746.39Z",
    fill: "#43200C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.359 21.068c.581 1.04 1.785 1.294 2.834 1.016.055-.014.133-.035.2-.055.152-.106.295-.224.428-.352.621-.554.747-.783.634-1.802.018-.018.019-.013 0 0 0-.016-.132.05-.163.088-.749.515-.52.241-1.276.71-.903.014-1.628.45-2.556.4a.209.209 0 0 0-.101-.005Z",
    fill: "#F26A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15 21.127a6.688 6.688 0 0 1-2.445-.01c-.257-.075-.377-.29-.595-.371a.47.47 0 0 0-.242-.047c-.358.667 3.19.819 3.325.577-.014-.05-.03-.1-.043-.149Z",
    fill: "#F36070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15 21.127c.596-.167 1.068-.881 1.22-1.116.175-.201-.064-.35.076-.538a.46.46 0 0 1 .177-.17c.663.367-1.185 2.104-1.43 1.973-.014-.05-.03-.1-.043-.149Z",
    fill: "#F36070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 74.5,
    r: 6.5,
    fill: "#FF4646"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 83.5,
    r: 1.5,
    fill: "#FF4646",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h122v133.32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCareHistoryLabWorks);
export default __webpack_public_path__ + "static/media/image_care_history_lab_works.48577d65.svg";
export { ForwardRef as ReactComponent };